// extracted by mini-css-extract-plugin
export default {"metricCardIcon":"MetricCardIcon_metricCardIcon__QHjTJ"};